<template>
  <div class="block block-rounded block-fx-shadow block-mode-loading-refresh" :class="{'block-mode-loading': isProcessing}">
    <div class="block-header block-header-default border-b mb-3">
        <h3 class="block-title">
          Общая статистика по статусам должников
        </h3>
        <div class="block-options">
          <button type="button" class="btn-block-option" @click="fetchStats()">
              <i class="si si-refresh"></i>
          </button>
        </div>
    </div>
    <div class="block-content block-content-full">
        <div class="pull-all">
          <doughnut-chart :chart-data="datacollection" :options="chartOptions" :height="150"></doughnut-chart>
        </div>
    </div>
  </div>
</template>

<script>
import DoughnutChart from '../../../partials/charts/DoughnutChart.js';

export default {
  components: {
    DoughnutChart,
  },
  props: [
    'userId',
  ],
  data() {
    return {
      isProcessing: false,
      datacollection: null,
      filter: {
        user_id: this.userId,
      },
      chartOptions: {
        responsive: true,
        maintainAspectRation: true,
        legend: {
          display: true,
          position: 'right',
          labels: {
            usePointStyle:true
          },
        },
      },
    };
  },
  mounted() {
    this.fetchStats();
  },
  methods: {
    fetchStats() {
      this.isProcessing = true;
      window.axios.get('/admin/charts/debts', { params: this.filter })
        .then((res) => {
          this.datacollection = res.data.chartdata;
          this.isProcessing = false;
        });
    },
  },
};
</script>
